'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setGtmDataLayer = setGtmDataLayer;
exports.clearGtmDataLayer = clearGtmDataLayer;
var SET_GTM_DATA_LAYER = exports.SET_GTM_DATA_LAYER = 'SET_GTM_DATA_LAYER';
var CLEAR_GTM_DATA_LAYER = exports.CLEAR_GTM_DATA_LAYER = 'CLEAR_GTM_DATA_LAYER';

function setGtmDataLayer(dataLayer) {
  return { type: SET_GTM_DATA_LAYER, dataLayer: dataLayer };
}

function clearGtmDataLayer() {
  return { type: CLEAR_GTM_DATA_LAYER };
}


//////////////////
// WEBPACK FOOTER
// ./shared/actions/gtm.js
// module id = 576
// module chunks = 0